"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLineChartYAxis = exports.useLineChartXAxis = void 0;
const lodash_1 = __importDefault(require("lodash"));
const utilities_1 = require("../../utilities");
const date_1 = require("../../utilities/date");
function prepareDomainTicksAndScale(_ref) {
  let {
    axisType,
    type,
    domain: oldDomain,
    customTicks,
    customDomain
  } = _ref;
  const hasCustomDomain = customDomain.some(cd => cd !== undefined);
  let ticks;
  let domain = [...oldDomain];
  if (customTicks) {
    ticks = customTicks.map(i => (0, date_1.dateParser)(i, type));
    // remove out of bounds ticks
    if (hasCustomDomain) {
      ticks = ticks.filter(nt => nt >= domain[0] && nt <= domain[1]);
    } else {
      // extend domain to include custom ticks
      domain = [lodash_1.default.min([domain[0], ticks[0]]), lodash_1.default.max([domain[1], lodash_1.default.last(ticks)])];
    }
  }
  const scale = (0, utilities_1.calculateScale)(type, domain);
  ticks = (0, utilities_1.getAxisTicks)({
    axisType,
    scale,
    customTicks: ticks
  });
  return {
    ticks,
    scale,
    domain
  };
}
const useLineChartXAxis = _ref2 => {
  let {
    type,
    keys,
    values: rawValues,
    customDomain = [undefined, undefined],
    customTicks = undefined
  } = _ref2;
  const axisType = 'x';
  const ogDomain = (0, utilities_1.parseDomain)(customDomain.map(i => i !== undefined ? (0, date_1.dateParser)(i, type) : undefined), [keys[0].formatted, lodash_1.default.last(keys).formatted]);
  const values = rawValues.filter(_ref3 => {
    let {
      formatted
    } = _ref3;
    return formatted >= ogDomain[0] && formatted <= ogDomain[1];
  }).map(_ref4 => {
    let {
      value
    } = _ref4;
    return value;
  });
  const axisOpts = prepareDomainTicksAndScale({
    axisType,
    type,
    domain: ogDomain,
    customDomain,
    customTicks
  });
  return {
    ...axisOpts,
    values
  };
};
exports.useLineChartXAxis = useLineChartXAxis;
const useLineChartYAxis = _ref5 => {
  let {
    type,
    values: rawValues,
    customDomain = [undefined, undefined],
    customTicks = undefined
  } = _ref5;
  const axisType = 'y';
  const minMaxValues = [lodash_1.default.min(rawValues), lodash_1.default.max(rawValues)];
  const hasCustomDomain = customDomain.every(cd => cd !== undefined);
  const ogDomain = (0, utilities_1.parseDomain)(customDomain.map(i => i !== undefined ? (0, date_1.dateParser)(i, type) : undefined), minMaxValues);
  const areAllPositive = minMaxValues.every(v => v >= 0);
  const areAllNegative = minMaxValues.every(v => v <= 0);
  if (!hasCustomDomain && (areAllPositive || areAllNegative)) {
    const absValues = rawValues.map(i => Math.abs(i));
    if (lodash_1.default.min(absValues) < 0.5 * lodash_1.default.max(absValues)) {
      ogDomain[areAllPositive ? 0 : 1] = 0;
    }
  }
  return prepareDomainTicksAndScale({
    axisType,
    type,
    domain: ogDomain,
    customDomain,
    customTicks
  });
};
exports.useLineChartYAxis = useLineChartYAxis;